import { CartPolicy } from './types';
import {
  cartWithoutPendingRemovals,
  findExistingCartLine,
  getAttr,
  mergeDedupAttributes,
  parseLineMaxQuantity,
  pass,
} from './cartLineHelpers';
import { isPickupLine } from '../bestBuyPickup';
import { GIFT_CARD_LINE } from '../giftCardLine';

export const duplicateLinePolicy: CartPolicy = (input, cart, meta) => {
  const lines = input.lineItemsToAdd;
  if (!lines?.length || !cart) return pass(input);

  const view = cartWithoutPendingRemovals(cart, input);
  const reasons: string[] = [];
  const next = lines.map((line) => {
    if (getAttr(line.attributes, 'sibling_id')) return line;
    // A Best Buy pickup ring is never merged with a line of the same
    // variant (off PRODUCTION it shares the normal ring's variant): the
    // merge would copy pickup properties onto a shipping ring, or an old
    // ring's trade-in and engraving onto the pickup ring.
    if (isPickupLine(line.attributes)) return line;
    // Each Ring voucher is its own card for its own recipient: never merged.
    if (getAttr(line.attributes, GIFT_CARD_LINE.sendToRecipient)) return line;

    const existing = findExistingCartLine(line, view, meta.store);
    if (!existing || isPickupLine(existing.attributes)) return line;
    // Each Ring voucher is its own card, with or without a recipient: never
    // merged. Same variant as a gift card line means it is a gift card too.
    if (existing.merchandise.product?.isGiftCard) return line;

    const effectiveMax =
      parseLineMaxQuantity(line.attributes) ??
      parseLineMaxQuantity(existing.attributes);
    reasons.push(`merge into existing line ${existing.id}`);
    return {
      merchandiseId: existing.merchandise.id,
      quantity: 1,
      attributes: mergeDedupAttributes(
        existing.attributes,
        line.attributes,
        effectiveMax,
      ),
      ...(line.sellingPlanId ? { sellingPlanId: line.sellingPlanId } : {}),
    };
  });

  return { input: { ...input, lineItemsToAdd: next }, reasons };
};
